<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p class="firstcenter"><a href="#/Text/Preface#toc_marker-6">Preface</a></p>
<p class="firstcenter"><a href="#/Text/Acknowledgments#toc_marker-7">Acknowledgments</a></p>
<table>
<tbody><tr>
<th colspan="5">Index to first letter</th>
</tr>
<tr>
<th><a href="#/Text/A#toc_marker-8"><span class="initial-cap">A</span></a></th>
<th><span href="#/Text/B#toc_marker-9" title="Link target outside of Sample"><span class="initial-cap">B</span></span></th>
<th><span href="#/Text/C#toc_marker-10" title="Link target outside of Sample"><span class="initial-cap">C</span></span></th>
<th><span href="#/Text/D#toc_marker-11" title="Link target outside of Sample"><span class="initial-cap">D</span></span></th>
<th><span href="#/Text/E#toc_marker-12" title="Link target outside of Sample"><span class="initial-cap">E</span></span></th>
</tr>
<tr>
<th><span href="#/Text/F#toc_marker-13" title="Link target outside of Sample"><span class="initial-cap">F</span></span></th>
<th><span href="#/Text/G#toc_marker-14" title="Link target outside of Sample"><span class="initial-cap">G</span></span></th>
<th><span href="#/Text/H#toc_marker-15" title="Link target outside of Sample"><span class="initial-cap">H</span></span></th>
<th><span href="#/Text/I#toc_marker-16" title="Link target outside of Sample"><span class="initial-cap">I</span></span></th>
<th><span href="#/Text/J#toc_marker-17" title="Link target outside of Sample"><span class="initial-cap">J</span></span></th>
</tr>
<tr>
<th><span href="#/Text/K#toc_marker-18" title="Link target outside of Sample"><span class="initial-cap">K</span></span></th>
<th><span href="#/Text/L#toc_marker-19" title="Link target outside of Sample"><span class="initial-cap">L</span></span></th>
<th><span href="#/Text/M#toc_marker-20" title="Link target outside of Sample"><span class="initial-cap">M</span></span></th>
<th><span href="#/Text/N#toc_marker-21" title="Link target outside of Sample"><span class="initial-cap">N</span></span></th>
<th><span href="#/Text/O#toc_marker-22" title="Link target outside of Sample"><span class="initial-cap">O</span></span></th>
</tr>
<tr>
<th><span href="#/Text/P#toc_marker-23" title="Link target outside of Sample"><span class="initial-cap">P</span></span></th>
<th colspan="2"><span href="#/Text/QR#toc_marker-24" title="Link target outside of Sample"><span class="initial-cap">Q, R</span></span></th>
<th><span href="#/Text/S#toc_marker-25" title="Link target outside of Sample"><span class="initial-cap">S</span></span></th>
<th><span href="#/Text/T#toc_marker-26" title="Link target outside of Sample"><span class="initial-cap">T</span></span></th>
</tr>
<tr>
<th><span href="#/Text/U#toc_marker-27" title="Link target outside of Sample"><span class="initial-cap">U</span></span></th>
<th><span href="#/Text/V#toc_marker-28" title="Link target outside of Sample"><span class="initial-cap">V</span></span></th>
<th><span href="#/Text/W#toc_marker-29" title="Link target outside of Sample"><span class="initial-cap">W</span></span></th>
<th colspan="2"><span href="#/Text/XYZ#toc_marker-30" title="Link target outside of Sample"><span class="initial-cap">X, Y, Z</span></span></th>
</tr>
</tbody></table>
<p class="firstcenter"><span href="#/Text/Bibliography#toc_marker-31" title="Link target outside of Sample">Bibliography</span></p>
<p class="firstcenter"><span href="#/Text/AboutTheAuthors#toc_marker-32" title="Link target outside of Sample">About the Authors</span></p>
<p class="firstcenter"><span href="#/Text/PocketRefCollection" title="Link target outside of Sample">Pocket Reference Collection from IVP Academic</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?25d422ca